import React from "react";
import EssenceFiles from "../../Essence/EssenceFiles";
import PropertyEdit from "../Property/PropertyEdit";
import ModelDetailDefault from "./ModelDetailDefault";
import ModelTabs from "./ModelTabs";

export default class ModelDetail extends React.Component {
  render() {
    const { mode, modelId } = this.props;
    return (
      <>
        {modelId !== "add" && <ModelTabs {...this.props} />}
        {mode === "default" && <ModelDetailDefault {...this.props} />}
        {mode === "prop" && (
          <PropertyEdit
            objectId={this.props.modelId}
            reference="model"
            referencekey="modelid"
          />
        )}
        {mode === "files" && (
          <EssenceFiles
            essence="model"
            id={this.props.modelId}
            key={this.props.modelId}
          />
        )}
      </>
    );
  }
}
